import { changePaymentType } from "../../../../actions/booking/changePaymentType"

async function submit(values, dispatch) {
    let bookingId = values?.bookingId, paymentType = parseInt(values?.paymentMethodId)
    await dispatch(changePaymentType({ bookingId, paymentType }))
}
export default submit